import React from "react";

import { Grid, Typography, Hidden, Button } from "@material-ui/core";
import { constantsApp } from "../../../constants/constants.app";

export default ({ setState, state }) => {
  const { showForm } = state;
  return (
    <Grid
      container
      alignContent="center"
      alignItems="center"
      justify="space-between"
    >
      <Typography variant="h4" gutterBottom>
        {constantsApp.layouts.headers.partner.TITLE}
      </Typography>
      {!showForm && (
        <Hidden smDown>
          <Grid item>
            <Grid
              container
              alignContent="center"
              alignItems="center"
              spacing={6}
            >
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      showForm: true,
                      showCreateParkingForm: true
                    }));
                  }}
                >
                  {constantsApp.layouts.headers.partner.ADD_PARKING_BUTTON}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      showForm: true,
                      showSendInvitationForm: true
                    }));
                  }}
                >
                  {constantsApp.pages.partnerPage.SEND_INVITATION_BUTTON}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => {
                    setState(prevState => ({
                      ...prevState,
                      showForm: true,
                      showConfigParkingForm: true
                    }));
                  }}
                >
                  {constantsApp.layouts.headers.partner.ADD_SCHEDULE_BUTTON}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
      )}
    </Grid>
  );
};
